module.exports = __webpack_public_path__ + "img/transfer-all.4b86a759.svg";